import * as React from "react";
import { compileShaders } from "./utils";
import lineFragmentShader from "./shaders/lineFragmentShader";
import lineVertexShader from "./shaders/lineVertexShader";
import areaFragmentShader from "./shaders/areaFragmentShader";
import areaVertexShader from "./shaders/areaVertexShader";
import dashLineFragmentShader from "./shaders/dashLineFragmentShader";
import dashLineVertexShader from "./shaders/dashLineVertexShader";
import scatterVertexShader from "./shaders/scatterVertexShader";
import scatterFragmentShader from "./shaders/scatterFragmentShader";
import "./style.scss";
import memoizeOne from "memoize-one";
export const WebGLContext = React.createContext(null);
export class CanvasGL extends React.Component {
    constructor(props) {
        super(props);
        this.ref = null;
        this.pendingDraw = false;
        this.updateFunctions = new Map();
        this.drawGl = () => {
            this.pendingDraw = false;
            this.clearCanvas(this.state.glContext);
            for (let update of this.updateFunctions.values()) {
                update();
            }
        };
        this.initWebGL = (canvas) => {
            let gl = null;
            try {
                gl = canvas.getContext("webgl", { preserveDrawingBuffer: false });
                this.clearCanvas(gl);
            }
            catch (e) { }
            return gl;
        };
        this.registerUpdate = (id, callback) => {
            this.updateFunctions.set(id, callback);
        };
        this.unregisterUpdate = (id) => {
            this.updateFunctions.delete(id);
        };
        this.requestUpdate = () => {
            if (!this.pendingDraw)
                requestAnimationFrame(this.drawGl);
            this.pendingDraw = true;
        };
        this.state = {
            glContext: null,
            lineShaders: null,
            scatterShaders: null,
            dashLineShaders: null,
            areaShaders: null,
        };
    }
    componentDidMount() {
        const glContext = this.initWebGL(this.props.glCanvasRef.current);
        const areaShaders = compileShaders(glContext, areaFragmentShader, areaVertexShader);
        const lineShaders = compileShaders(glContext, lineFragmentShader, lineVertexShader);
        const dashLineShaders = compileShaders(glContext, dashLineFragmentShader, dashLineVertexShader);
        const scatterShaders = compileShaders(glContext, scatterFragmentShader, scatterVertexShader);
        this.setState({
            glContext,
            lineShaders,
            scatterShaders,
            dashLineShaders,
            areaShaders,
        });
    }
    clearCanvas(gl) {
        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        gl.clearDepth(1.0);
        gl.enable(gl.BLEND);
        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.SRC_ALPHA, gl.DST_ALPHA);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(this.state.glContext.COLOR_BUFFER_BIT);
    }
    render() {
        const { width, height, margins, children, glCanvasRef } = this.props;
        const { glContext } = this.state;
        var devicePixelRatio = window.devicePixelRatio || 1;
        const contextValue = getContextValue(this.state, this.registerUpdate, this.unregisterUpdate, this.requestUpdate);
        return (React.createElement(React.Fragment, null,
            React.createElement("canvas", { className: "canvas_gl", key: "canvasGL", width: (width - margins.right - margins.left) * devicePixelRatio, style: {
                    left: margins.left,
                    top: margins.top,
                    width: width - margins.right - margins.left,
                    height: height - margins.top - margins.bottom,
                }, height: (height - margins.top - margins.bottom) * devicePixelRatio, ref: glCanvasRef },
                "Your browser doesn't appear to support HTML5",
                React.createElement("code", null, "<canvas>"),
                " element."),
            React.createElement(WebGLContext.Provider, { value: contextValue }, glContext ? children : React.createElement("div", null, "Loading..."))));
    }
}
const getContextValue = memoizeOne((state, registerUpdate, unregisterUpdate, requestUpdate) => {
    return Object.assign(Object.assign({}, state), { canvas: state.glContext, registerUpdate,
        unregisterUpdate,
        requestUpdate });
});
//# sourceMappingURL=index.js.map